/**
 * 마이크로소프트 클래리티(화면 녹화) — 로그인한 손님을 녹화에 묶는다.
 *
 * 왜(2026-10-22 대표 7841·7844): "니가 그거 보고 행동분석 다 할수있어야해", "가리지마 절대 그러면 유저 누구인지 영영 알수없어".
 * 태그는 index.html 맨 위(프로젝트 uwm7ttv2nk)가 window.clarity를 만든다. 스크립트가 아직 안 왔거나 막혔으면
 * 호출은 대기열(clarity.q)에 쌓였다가 스크립트가 뜨면 처리된다. 주소가 바뀌면(화면 이동) 클래리티는 새 페이지로 다시 시작하므로
 * 화면마다 다시 부른다(클래리티 안내: 페이지마다 identify).
 * - 회원 번호(uuid)는 클래리티가 손님 브라우저에서 해시로 바꿔 보낸다 → 대시보드 필터 '사용자 지정 ID'에 회원 번호를 넣으면 찾힌다.
 * - 친근한 이름(대시보드에 그대로 보이는 이름) = 연결된 인스타 아이디. 연결 전이면 비우고, 클래리티가 회원 번호 앞 두 글자만 보여 준다.
 */
type ClarityFn = (...args: unknown[]) => void;

export function identifyClarityUser(userId: string, instagramUsername: string | null): void {
    if (typeof window === 'undefined') return;
    const clarity = (window as unknown as { clarity?: ClarityFn }).clarity;
    if (typeof clarity !== 'function') return;
    clarity('identify', userId, undefined, undefined, instagramUsername || undefined);
}
